export default "__VITE_ASSET__C1roIW$n__"